export default __webpack_public_path__ + "8fc9ca0c61ff2ce927eec92d1d3503e0.riv";